import React, { PureComponent } from "react";
import {
  Card,
  Badge,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { Separator } from "../../../components/common/CustomBootstrap";
import { AddCommaNumber, AddCommaPhoneNumber } from "../../../helpers/Utils";

class LabelItemLeft extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems,
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames],
    );
  };

  render() {
    // console.log('render LeftFormComponent');
    const { dropdownSplitOpen } = this.state;
    const { item, setting, selectedItems } = this.props;
    return (
      <Card className="mb-3 custom-shadow">
        <div className="d-flex flex-row cursor-pointer">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            {/* Simple Checkbox - for multi-select */}
            <div
              className="custom-control custom-checkbox align-self-center"
              style={{
                padding: "15px 15px 15px 20px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.props.onChangeCheckbox(item.id, e);
              }}
            >
              <CustomInput
                type="checkbox"
                id={`check-customer-${item.id}`}
                label=""
                checked={selectedItems.includes(item.id)}
                onChange={() => {}}
                style={{ cursor: "pointer" }}
              />
            </div>
            {item.at ? (
              <div
                onClick={() => {
                  this.onClickedItem(item);
                }}
                className={classnames(
                  "card-body align-self-center d-flex flex-ssm-column justify-content-between min-width-zero",
                  {
                    "flex-lg-row align-items-lg-center": !setting.update,
                  },
                )}
              >
                <div className="w-50 list-item-heading mb-1 truncate d-block w-sm-100 text-capitalize">
                  <span>{item.name}</span>
                </div>
                <div className="w-50">
                  <Badge color={"primary"} pill>
                    {item.at}
                  </Badge>
                </div>
              </div>
            ) : (
              <div
                onClick={() => {
                  this.onClickedItem(item);
                }}
                className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center py-3 pl-0"
              >
                <div className="align-self-center d-flex flex-column justify-content-between">
                  <div className="list-item-heading mb-1 truncate d-block text-capitalize">
                    {item.name !== "" ? (
                      <span>{item.name}</span>
                    ) : (
                      <span>{item.phone}</span>
                    )}
                  </div>
                  <div className="text-muted text-small">
                    Số điện thoại: {item.phone}
                  </div>
                  <div className="text-muted text-small mt-3">
                    <span className={item.debt > 0 && "text-primary"}>
                      Còn nợ: {AddCommaNumber(item.debt)}đ
                    </span>{" "}
                    - Số điểm: {AddCommaNumber(item.point)}
                  </div>
                </div>
                <div className="w-sm-100">
                  {item.armorial !== "" ? (
                    <Badge color="primary" pill className="spacer-around-1">
                      {item.armorial}
                    </Badge>
                  ) : null}
                </div>
              </div>
            )}
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
